import React from "react";

interface OrderStatusBadgeProps {
  status:
    | "pending"
    | "dispatch_ready"
    | "accepted"
    | "in_transit"
    | "delivered"
    | "por_facturar"
    | "facturado";
}

const badgeData = {
  pending: {
    className: "bg-amber-100 text-amber-600 border-amber-600",
    label: "Pendiente",
  },
  dispatch_ready: {
    className: "bg-blue-100 text-blue-600 border-blue-600",
    label: "Con Guía",
  },
  accepted: {
    className: "bg-green-100 text-green-600 border-green-600",
    label: "Aceptado",
  },
  in_transit: {
    className: "bg-blue-100 text-blue-600 border-blue-600",
    label: "En tránsito",
  },
  delivered: {
    className: "bg-purple-100 text-purple-600 border-purple-600",
    label: "Entregado",
  },
  por_facturar: {
    className: "bg-orange-100 text-orange-600 border-orange-600",
    label: "Por Facturar",
  },
  facturado: {
    className: "bg-indigo-100 text-indigo-600 border-indigo-600",
    label: "Facturado",
  },
};

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({
  status,
}) => {
  const badge = badgeData[status];
  if (!badge) return null;
  return (
    <div
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors ${badge.className}`}
    >
      {badge.label}
    </div>
  );
};
